const isImage = (mediaName) => {
  return !!(new RegExp('.jpg|.png|.gif').test(mediaName));
};
    
export default isImage;